// components
import PeriodInput from 'components/shared/PeriodInput/PeriodInput';

// hooks
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// types
import type { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import type { Period } from 'components/shared/PeriodInput/PeriodInput.types';

const DateTimePeriodSection = () => {
  'use memo';
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });

  const {
    setValue,
    control,
    formState: { errors }
  } = useFormContext<AppointmentFormFieldData>();

  const [appointmentStart, appointmentEnd, recurrenceRule] = useWatch({
    name: ['start', 'end', 'recurrencePattern.recurrenceRule'],
    control
  });

  const label = recurrenceRule != 'none' ? t('patternStart') : t('date');
  const period = {
    start: appointmentStart ? new Date(appointmentStart) : new Date(),
    end: appointmentEnd ? new Date(appointmentEnd) : new Date()
  };
  const endTimeError = !!errors ? errors['end']?.message : null;

  const onChange = (period: Period) => {
    const updateOptions = {
      shouldDirty: true,
      shouldValidate: true
    };

    setValue('start', period.start.toISOString(), updateOptions);
    setValue('end', period.end.toISOString(), updateOptions);
  };

  return (
    <PeriodInput
      label={label}
      period={period}
      error={endTimeError}
      onChange={onChange}
    />
  );
};

export default DateTimePeriodSection;
